import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { Footer } from '@/components/generals/footer'
import { Navbar } from '@/components/generals/navbar'

export const Layout: FC<LayoutProps> = ({ children }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col'>
            <a
                href='#main'
                className='sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[200] focus:rounded-full focus:bg-ink focus:px-5 focus:py-3 focus:text-sm focus:text-cream'
            >
                Saltar al contenido
            </a>

            <Navbar />

            <main
                id='main'
                className='flex-1'
            >
                {children}
            </main>

            <Footer />
        </div>
    )
}
